<wiz-hgroup #argContainer wizValidationContainer width="100%" height="100%">
  
  <!-- drop pour les valeurs de args -->
  <form-drop-extended-renderer
    #ddext *ngIf="useddext"
    width="100%"
    [manageModel] = false
    [wizShowLabel]="showLabel"
    [wizMandatory]="checkMandatory"
    [data]="ffoValue"
    [wizDisabled]="wizdisabled"
    [ngClass]="injectClass"
    ></form-drop-extended-renderer>

  <wiz-text-input
    #tiObject *ngIf="usetiObject"
    [wizValue]="formatedValue"
    [wizLabel]="alternateLabel"
    width="100%"
    [wizShowLabel]="showLabel"
    [ngClass]="injectClass"
  ></wiz-text-input>

  <!-- rendu type commentaire -->
  <wiz-text-area
    #ta *ngIf="useta"
    [wizLabel]="alternateLabel"
    [wizMaxChars]="wizmax"
    [wizDisabled]="readOnly"
    [wizValue]="formatedValue"
    [wizValidator]="checkValueAvailable()"
    [wizMandatory]="checkMandatory"
    width="100%"
    height="100%"
    [ngClass]="injectClass"
    [wizShowLabel]="showLabel"></wiz-text-area>


  <wiz-text-input
    #ti *ngIf="useti"
    [wizMaxChars]="wizmax"
    [wizValue]="formatedValue"
    [wizRestrict]="forceRestrict"
    [wizLabel]="alternateLabel"
    [wizValidator]="checkValueAvailable()"
    [wizMandatory]="checkMandatory"
    [ngClass]="[forceCaps, injectClass]"
    wizShowErrors="true"
    width="100%"
    [wizShowLabel]="showLabel"
    [wizDisabled]="readOnly"
  ></wiz-text-input>

  <wiz-numeric-input
    #ni *ngIf="useni"
    [wizLabel]="alternateLabel"
    [wizMaxChars]="20"
    [wizValidator]="checkValueAvailable()"
    [wizMandatory]="checkMandatory"
    wizShowErrors="true"
    [nbDecimal]="decimal"
    [wizMinNumber]="wizmin"
    [wizMaxNumber]="wizmax"
    [wizNumber]="formatedValue"
    width="100%"
    [wizShowLabel]="showLabel"
    [ngClass]="injectClass"
    (wizKey)="fastChange(ni, $event)"
    [wizDisabled]="readOnly"></wiz-numeric-input>

  <wiz-datefield #da 
  *ngIf="useda"
  [wizLabel]="alternateLabel"
  [wizNumberValue]="formatedValue"
  [wizValidator]="checkValueAvailable()" 
  wizShowErrors="true" 
  [wizMandatory]="checkMandatory" 
  width="100%" wizFocusMode="PASS"
  [wizShowLabel]="showLabel"
  [ngClass]="injectClass"
  (wizKey)="fastChange(da, $event)"
  [wizDisabled]="readOnly"></wiz-datefield>

  <wiz-checkbox #cb *ngIf="usecb" 
  [wizTriStateMode]="false" 
  [wizLabel]="alternateLabel"
  [ngClass]="injectClass"
  [wizChecked]="formatedValue"
  
  [wizShowLabel]="showLabel"></wiz-checkbox>

  <wiz-group #imgGp *ngIf="useimgGp" width="100%" height="100%" style="margin: 3px;"><!-- rendu d'un média du FDV-->
    <wiz-vgroup gap="0" [ngClass]="injectClass" width="100%" height="100%">
      <wiz-label #imgLbl  
      [wizLabel]="alternateLabel"
      class="componentLabel" 
      [visible]="showLabel"></wiz-label>
      <wiz-vgroup gap="0" width="100%" height="100%" 
          horizontalAlign="center" verticalAlign="center"
      >
      <!-- TODO TODO    -->
      <wiz-image style="padding: 3px;"
          #img
          tabindex="0"
          height="100%"
          width="100%"
          class="img-picker img-freestyle"
          [useHandCursor]="true"
          [blobid]="imgBlobid"
          [sourceObservable]="imgSrcObs"
          (keydown)="keydownForUpload($event)"
          wizholdable
          (wizTap)="clickForUpload(-1, imgBlobid, false, $event)"
          (wizHold)="clickForUpload($event, imgBlobid, false, 'desktop')"
          >

        </wiz-image>
      </wiz-vgroup>
      
    </wiz-vgroup>
    <wiz-hgroup width="100%">
      <wiz-spacer width="100%"></wiz-spacer>
      <wiz-icon
        [visible]="hasImage && !readOnly"
        style="cursor: pointer; font-size: 20px"
        (click)="clearImage()"
        class="image-back-white"
        [wizTooltip]="'$.common.delete.$'"
        >delete</wiz-icon>
    </wiz-hgroup>
    
  </wiz-group>

  <wiz-button #bt *ngIf="usebt" 
  class="button-connect"
  [wizLabel]="cnx?.trsLabel"
  [tooltipText]="cnx?.trsDescription"
  [wizImage]="cnx?.iconOrDie"
  [ngClass]="injectClass"
  width="100%" (wizClick)="doArgAction()"></wiz-button>

  <!-- zone de drop -->

  <wiz-vgroup *ngIf="useDropGrp" width="100%" height="100%" [ngClass]="injectClass">
    <wiz-label #colorLbl id="label" 
    [wizLabel]="alternateLabel"
    class="componentLabel" 
    [visible]="showLabel"></wiz-label>
  
    <wiz-group #dropGrp *ngIf="useDropGrp" width="100%" height="100%">
      
      <wiz-vgroup #dropEmpty class="dropZone" *ngIf="!dropFull"
        width="100%" height="100%" horizontalAlign="center" verticalAlign="center" [ngClass]="injectClass"
        (click)="selectFile()" (drop)="dropFile($event)" (dragover)="dover($event)">
        
        <wiz-icon #icoAddFile [wizTooltip]="'$.common.import.$'">upload</wiz-icon>
        <wiz-label wizLabel="$.common.free.drop.message.$"></wiz-label>
      </wiz-vgroup>
      
      <wiz-hgroup #dropFull class="dropZone" *ngIf="dropFull" 
      horizontalAlign="center" verticalAlign="center" style="padding: 5px;"
      width="100%" height="100%">
        <wiz-label [wizLabel]="mediaReference?.shortFileName" [wizTooltip]="mediaReference.fileName" width="100%"
        style="word-break: break-all;"></wiz-label>
        <wiz-vgroup width="28px">
          <wiz-icon #icoDelFile
          style="cursor: pointer; font-size: 20px"
          [visible]="!readOnly"
          (click)="clearDropFile()"
          [wizTooltip]="'$.common.delete.$'">delete</wiz-icon>
          <wiz-icon #icoLoadFile 
          [undisableable]="true"
          style="cursor: pointer; font-size: 20px" (click)="loadDropFile()" [wizTooltip]="'$.common.export.$'">download</wiz-icon>
        </wiz-vgroup>
      </wiz-hgroup>
    </wiz-group>
  </wiz-vgroup>

  <!-- html libre -->
  <wiz-hgroup #freeGrp *ngIf="usefreeGrp" [visible]="readyfreeGrp" width="100%" height="100%">
    <angular-editor #ae width="100%" height="100%" style="pointer-events: none;"></angular-editor>
  </wiz-hgroup>
  
  <!-- image libre Embedded (en cache) -->
  <wiz-hgroup #freeImgGrp *ngIf="usefreeImgGrp" width="100%" height="100%">
    <wiz-image
        class="img-freestyle"
        [sourceObservable]="imgSrcObs"
        #freeImg
        tabindex="0"
        height="100%"
        width="100%"></wiz-image>
  </wiz-hgroup>

  <!-- rendu lien hypertexte sur un texte -->
  <wiz-hgroup #linkGp *ngIf="uselinkGp" width="100%" height="100%"> <!-- rendu texte du FDV au format hyperText-->
    <div><a href="{{linkUrl}}" target="_blank">{{linkLabel}}</a></div>
  </wiz-hgroup>

  <!-- rendu de type "media" sur un texte -->
  <wiz-hgroup #mediaGrp *ngIf="usemedia" width="100%" height="100%">
    <wiz-image
        class="img-freestyle"
        [source]="formatedValue"
        #mediaImg
        tabindex="0"
        height="100%"
        width="100%"></wiz-image>
  </wiz-hgroup>

  <!-- color picker -->
  <wiz-vgroup *ngIf="usecolor" width="100%" height="100%" [ngClass]="injectClass">
    <wiz-label #colorLbl id="label" 
    [wizLabel]="alternateLabel"
    class="componentLabel" 
    [visible]="showLabel"></wiz-label>
    <wiz-hgroup>
      <span
        #cellBlockBack
        [style.backgroundColor]="formatedValue"
        width="20px"
        height="20px"
        (click)="showColorPicker($event)"
        style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
      ></span>
      <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('cellBlockBack')">removal</wiz-icon>
    </wiz-hgroup>
  </wiz-vgroup>

  <!-- workflow -->
  <wiz-vgroup #workflowGroup *ngIf="useworkflow" width="100%" height="100%" [ngClass]="injectClass">
      <wiz-label #colorLbl id="label" 
      [wizLabel]="alternateLabel"
      class="componentLabel" 
      [visible]="showLabel"></wiz-label>
    <wiz-hgroup width="100%" height="100%" id="inzone"
      verticalAlign="center">
        
      <wiz-image *ngIf="!!workImageBlob"
        class="img-freestyle"
        [sourceObservable]="workImage"
        #workImg
        tabindex="0"
        height="90%"
        style="aspect-ratio: 1;"
        ></wiz-image>
      
      <wiz-icon class="image-purple-nohover" *ngIf="!!workIcon">
          <mat-icon class="material-icons">{{workIcon}}</mat-icon></wiz-icon>

      
      <wiz-vgroup width="100%" height="100%" horizontalAlign="center" verticalAlign="center">
         <wiz-hgroup width="100%" verticalAlign="center" style="overflow-y: auto;">
            <span class="wiz-cell-text" >{{workflowLabel}}</span>
        </wiz-hgroup>  
        
        <!-- <wiz-label #workflowLbl width="100%" 
          [wizLabel]="workflowLabel" style="align-items: center;">
          </wiz-label> -->
        
          <!-- pièce jointe -->
          <wiz-hgroup #dropFull class="dropZone" *ngIf="workFile" 
                horizontalAlign="center" verticalAlign="center" style="padding: 5px;"
                width="100%" height="30px">
                  <wiz-label [wizLabel]="workFile?.shortFileName" [wizTooltip]="workFile.fileName" width="100%"
                  style="word-break: break-all;"></wiz-label>
                  <wiz-vgroup width="28px">  
                    <wiz-icon #icoLoadWorkFile 
                    [undisableable]="true"
                    style="cursor: pointer; font-size: 20px" (click)="loadDropWorkFile()" [wizTooltip]="'$.common.export.$'">download</wiz-icon>
                  </wiz-vgroup>
                </wiz-hgroup>



      </wiz-vgroup>   





        <wiz-icon class="image-purple"
        [visible] = !argContainer?.wizDisabled (click)="showWorkflow($event)">edit</wiz-icon>
    </wiz-hgroup>
  </wiz-vgroup>

  <!-- images multiples -->
  <wiz-group #imgMultiGp *ngIf="useimgMultiGp" width="100%" height="100%" style="margin: 3px;"><!-- rendu d'un média mode multi-->
    <wiz-vgroup gap="0" [ngClass]="injectClass" width="100%" height="100%">
      <wiz-hgroup width="100%">
        <wiz-label #imgMultiLbl id="label"  
              [wizLabel]="alternateLabel"
              class="componentLabel" 
              [visible]="showLabel"></wiz-label>
              <wiz-icon #icoCam
                [visible]="!readOnly && !onlyOneOnMulti"
                style="cursor: pointer; font-size: 24px"
                (click)="addMultiImage(true)"
                class="image-back-white"
                [wizTooltip]="'$.image.mode.camera.$'">
                <mat-icon style="font-size: 26;">camera</mat-icon></wiz-icon>

              <wiz-icon #icoMulti
                [visible]="!readOnly && !onlyOneOnMulti && !gatlingMode"
                style="cursor: pointer; font-size: 24px"
                (click)="addMultiImage()"
                class="image-back-white"
                [wizTooltip]="'$.common.add.$'">
                <mat-icon style="font-size: 26;">add_circle_outline</mat-icon></wiz-icon>

              <wiz-icon #icoSwap
                [visible]="!readOnly && !!moreThanOne && !gatlingMode"
                style="cursor: pointer; font-size: 24px"
                (click)="swap()"
                class="image-back-white"
                [wizTooltip]="'$.step.partition.sort.$'">
                <mat-icon style="font-size: 26;">swap_horiz</mat-icon></wiz-icon>

      </wiz-hgroup>
     
      <!-- <div width="100%" height="100%" style="overflow-x: auto; overflow-y: hidden;"> -->
      <wiz-hgroup #imgMultiContainer id="imgMultiContainer" gap="2" width="100%" height="100%" 
        style="overflow: auto hidden !important">
        

      <wiz-group *ngFor="let item of blobList"
        [style.width.px]="imageRatio" [style.minWidth.px]="imageRatio"
        [style.height.px]="imageRatio">
          <wiz-image  
          tabindex="0"
          width="100%"
          height="100%"
          class="img-picker img-freestyle"
          [useHandCursor]="true"
          [blobid]="item.blobId"
          [sourceObservable]="item.obs"
          thumb="true"
          style="pointer-events: none;">
          <!-- on force le zoom, quelle que soit la durée (click)="seeImageMulti(getBlobObs(item))"> -->
        </wiz-image>
        <!-- <div style='z-index: 100; width:100%; height:100%; cursor: pointer;'></div> -->
        <div style='z-index: 100; width:100%; height:100%; cursor: pointer;'
            wizholdable
            
            (wizTap)="clickForUpload(-1, item.blobId, true, $event, true)"
            (wizHold)="clickForUpload($event, item.blobId, true, 'desktop')"></div>

        <wiz-hgroup width="100%" style='z-index: 200;'>
          <wiz-spacer width="100%"></wiz-spacer>
          <wiz-icon
          [visible]="hasImage && !readOnly && !onlyOneOnMulti"
          style="cursor: pointer; font-size: 20px"
          (click)="clearImageMulti(item.blobId)"
          class="image-back-white"
          [wizTooltip]="'$.common.delete.$'"
          >delete</wiz-icon>

        </wiz-hgroup>        
      
      </wiz-group>

      </wiz-hgroup>  
    </wiz-vgroup>
 
  </wiz-group>

  <!-- container -->
  <wiz-vgroup #freeZone *ngIf="usefreeZone" width="100%" height="100%" gap="-10">
    <wiz-hgroup width="100%" height="100%" verticalAlign="center"
    style="border-bottom-style: solid; border-width: 1px; border-color: #e9e9e9;" [ngClass]="injectClass">
      <wiz-icon #icoZone id="label"
        style="cursor: pointer; font-size: 20px"
        (click)="showHideZone()"
        [wizTooltip]="freezonelabel">
        {{freezoneicon}}</wiz-icon>
      
        <wiz-label #freeZoneLbl id="label" width="100%"
        [wizLabel]="alternateLabel"
        class="componentLabel" 
        [visible]="showLabel"></wiz-label>
    </wiz-hgroup>
  </wiz-vgroup>
  
  <!-- rendu liste de sous-éléments -->
  <wiz-hgroup #listGP *ngIf="uselistGP" width="100%" height="100%">
    <wiz-vgroup gap="0" [ngClass]="injectClass">
      <wiz-hgroup width="100%">
        <wiz-label #listLbl class="componentLabel" id="label" width="100%" 
        [wizLabel]="alternateLabel"
        [visible]="showLabel"></wiz-label>
        <i #icoList id="ico" 
        class="wiz-icon- cell-edit-icon" 
        style="font-size: 18px; cursor: pointer"
        (click)="showListPop($event)">edit</i>
      </wiz-hgroup>

      <div innerHTML="{{ formatedValue }}" id="inzone"></div>
    </wiz-vgroup>  
  </wiz-hgroup>

  <!-- rendu threshold -->
  <wiz-hgroup #thresholdGP *ngIf="usethresholdGP" width="100%" height="100%">
    <wiz-vgroup gap="0" [ngClass]="injectClass">
      <wiz-hgroup width="100%">
        <wiz-label #listLbl class="componentLabel" id="label" width="100%" 
        [wizLabel]="alternateLabel"
        [visible]="showLabel"></wiz-label>
        <i #icoThreshold id="ico" 
        class="wiz-icon- cell-edit-icon" 
        style="font-size: 18px; cursor: pointer"
        (click)="showThresholdPop($event)">edit</i>
      </wiz-hgroup>

      <div innerHTML="{{ formatedValue }}" id="inzone"></div>
    </wiz-vgroup>  
  </wiz-hgroup>


</wiz-hgroup>
